import { useQuery } from "@tanstack/react-query"
import requests from "../services/requests"

const useGetUserProfile = () => {
  const query = useQuery({
    queryKey: ["GET_DASHBOARD_USER_PROFILE"],
    queryFn: async () => {
      const { data } = await requests.getProfile()

      return data?.value || []
    },
    gcTime: 0,
    placeholderData: []
  })

  return query
}

export default useGetUserProfile
